var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
var NavHelpSell = function NavHelpSell(_a) {
  var loaded = _a.loaded,
    width = _a.width,
    height = _a.height,
    imgProps = __rest(_a, ["loaded", "width", "height"]);
  if (loaded) {
    return /*#__PURE__*/React.createElement("img", Object.assign({}, imgProps));
  }
  return /*#__PURE__*/React.createElement(Skeleton, Object.assign({
    width: width,
    height: height
  }, imgProps));
};
export default NavHelpSell;